import React, { useState, useEffect, useMemo } from "react";
import eventClasses from "./workschedulegrouping.module.scss";
import classes from "../../controls.module.scss"
import {
    FormControlLabel,
    FormControl,
    TextField,
    Button,
    Grid,
    Box,
    Typography
} from '@mui/material';
import bloomiesReceiptIcon from "../../../../Resources/bloomiesrcpt.png"
import { Checkbox } from '@genesis/ui-kit';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Icon } from '@genesis/ui-kit';
import axios from "axios";
import axiosInstance from "../../../../Shared/Utill/AxiosConfig";
import { useSelector } from "react-redux";
import Cookie from "js-cookie";
import useToggle from "@genesis/ui-kit/dist/hooks/useToggle";
import { useLocation } from "react-router-dom";
import NotificationView from "../../../../Shared/Notification/NotificationView";
import { useNavigate, NavLink } from "react-router-dom";
import { constants } from "../../../../Shared/Url/Constants";
import { CheckIsUserAdmin, convertDateToMMDDYYYYString } from "../../../../Shared/Utill/Utills";
import AdminControlsDataGrid from '../../AdminControlsDataGrid';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import SnackBar from "../../../../Shared/Snackbar/Snackbar";
import add from "../../../../Resources/add.png";
import deleteimg from "../../../../Resources/delete.png";
import add_disable from "../../../../Resources/add_disable.png";
import delete_disable from "../../../../Resources/delete_disable.png";
import DeleteEventDialog from "../../EventParentControls/DeleteEvent/DeleteEventDialog";
import { Dialog } from '@genesis/ui-kit';
import { isString } from '../../../../Shared/Utill/Utills';
import {AllControlSearchView} from "../RuleAssignments/Search/RuleAssignmentsSearch"

const AddEditWorkScheduleGrouping = () => {
    const personDetails = useSelector((state) => state.person.personData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const colleagueTKN = Cookie.get('X_TKN');
    const token = Cookie.get('X_TKN');
    const dialog = useToggle();
    const location = useLocation();
    const [isAlertOpen, setAlertOpen] = React.useState({});
    const [workSchedule, setWorkSchedule] = React.useState("");
    const [groupId, setGroupId] = React.useState("");
    const [isDirty, setIsDirty] = React.useState({ work: false, group: false })
    console.log("data from search parent!" + JSON.stringify(location.state.id))
    const [flag, setFlag] = React.useState(location.state.flag);
    const [wsId, setWsId] = React.useState(location.state.id);
    const history = useNavigate();
    const { message, severity, open } = isAlertOpen || {};
    const [readOnlyView, setReadyOnly] = React.useState(true);
    const [ongoingActionCompleted, setOngoingActionCompleted] = React.useState(true);
    const [isFromSearch,setIsFromSearch] = useState(location.state.isSearch || false);

    useEffect(() => {
        if (flag === "A") {
            makeEditable();
        } else {
            // call api to get details
            getWorkScheduleGroupingDetails();
        }
    }, []);

    const getWorkScheduleGroupingDetails = (id=null) => {
        // call api to get edit details
        let wsId = id === null ? location.state.id : id
        let url =`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAILABILITY_WORK_SCHEDULE_GET_WORK_SCHEDULES_BY_WSID}/${wsId}`

       axiosInstance.get(url,
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        }).then((res) => {
            console.log(res)                    
            setWorkSchedule(res.data.workSchedule);
            setGroupId(res.data.groupId);
                           
        }).catch((err) => {
            setAlertOpen({
                open: true,
                severity: "error",
                message : err.response.data.message,
              })
        });
        
       //setWorkSchedule("TEST")
    }

    const cancelEditing = () => {
        if(flag === "A" && !isFromSearch){
            // on page add case
            setOngoingActionCompleted(true);
            // call api to reset values
            makeReadOnly();
            setFlag("E");
            setIsFromSearch(false);
            getWorkScheduleGroupingDetails();
      
            history("/controls/availabilityapplicationcontrols/workschedulegrouping/Edit",{ state: { flag: "E", isSearch: false, id: location.state.id}});
          }else if(flag === "E" && !isFromSearch) {
            setOngoingActionCompleted(true);
            // call api to reset values
            getWorkScheduleGroupingDetails();
            makeReadOnly();
          } else {
            history('/controls/availabilityapplicationcontrols/workschedulegrouping');
          }
    }

    const makeEditable = () => {
        setOngoingActionCompleted(false);
        console.log(readOnlyView + " ready only ")
        if (readOnlyView == true) {
            setReadyOnly(false)
        }
    }
    const makeReadOnly = () => {
        //on click of save
        setOngoingActionCompleted(true);
        if (readOnlyView == false) {
            setReadyOnly(true)
        }
    }


    const handleAlertNotifClose = () => {
        setAlertOpen({});
    };

    const saveData = () => {
        let err = "";
        if(workSchedule === "" || groupId === "") {
            err = "error";
            if(workSchedule === "" && groupId === "") { setIsDirty({ ...isDirty, "group": true, "work": true });  } 
            if(workSchedule === "" && groupId !== "") { setIsDirty({ ...isDirty, "group": false, "work": true });  } 
            if(workSchedule !== "" && groupId === "") { setIsDirty({ ...isDirty, "group": true, "work": false });  } 
        }

        if(isString(groupId)) {
            err = "error";
            setAlertOpen({
                open: true,
                severity: "error",
                message: "Group ID should be numeric.",
            })

        }
        
        if(err === "") {

            if(flag === "A") {
                // save data and call edit api
                let data = {
                    workSchedule: workSchedule,
                    groupId: groupId,
                    lastUpdatedBy: personDetails.emplID
                } 
                axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAILABILITY_WORK_SCHEDULE_ADD_NEW}`,
                data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token,
                    }
                }).then((res) => {
                    console.log(res)                    
                    setAlertOpen({
                        open: true,
                        severity: "success",
                        message : "Work Schedule added successfully",
                      })
                      makeReadOnly();
                      setFlag("E");
                      setWsId(res.data.wsId);
                      getWorkScheduleGroupingDetails(res.data.wsId);
                                   
                }).catch((err) => {
                    let message = err.response.data.message;
                    if(message === "Duplicate record not allowed.") {
                        message = "Work Schedule already exists";
                    }
                    setAlertOpen({
                        open: true,
                        severity: "error",
                        message : message,
                      })
                });
                
            } else {
                let data = {
                    wsId: wsId,
                    workSchedule: workSchedule,
                    groupId: groupId,
                    lastUpdatedBy: personDetails.emplID
                } 
                axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAILABILITY_WORK_SCHEDULE_EDIT_WORK_SCHEDULE}`,
                data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token,
                    }
                }).then((res) => {
                    console.log(res)                    
                    setAlertOpen({
                        open: true,
                        severity: "success",
                        message : "Work Schedule updated successfully",
                      })
                      makeReadOnly();
                      getWorkScheduleGroupingDetails(res.data.wsId);
                                   
                }).catch((err) => {
                    let message = err.response.data.message;
                    if(message === "Duplicate record not allowed.") {
                        message = "Work Schedule already exists";
                    }
                    setAlertOpen({
                        open: true,
                        severity: "error",
                        message : message,
                      })
                });
                
            }
        } // check if no error
         
    }
    
    const addWorkScheduleGrouping = () => {
        setIsFromSearch(false)
        setFlag("A");
        makeEditable();
        setWorkSchedule("");
        setGroupId("");
        history('/controls/availabilityapplicationcontrols/workschedulegrouping/Add',{ state: { flag: "A", isSearch: false, id: location.state.id }});
    }

    const setTouched = (field) => {
        field === "group" ? setIsDirty({ ...isDirty, "group": true }) : setIsDirty({ ...isDirty, "work": true })
    }

    const showDeleteDialog = () => {
        dialog.show()
    }

    const deleteWorkSchedule = () => {

        axiosInstance.delete(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAILABILITY_WORK_SCHEDULE_DELETE_BY_WSID}/${wsId}`, {
            headers: {
                'content-type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then((res) => {
            dialog.hide();
            history("/controls/availabilityapplicationcontrols/workschedulegrouping", {state:`DeleteLocation`})
        }).catch((err) => {

        });
    }

    return (

        <div className={""}>

            <div style={{ width: "100%" }}>
            <div className={classes.pagemargin}><AllControlSearchView /></div>
                <div className={eventClasses.eventpagetitle} style={{ textAlign: "left", width: "40%" }} >{flag === "E" ? workSchedule : "Add"}</div>
                <div className={eventClasses.eventpagetitle} style={{ textAlign: "right", width: "55%" }}>
                    <div className={eventClasses.eventicon2} ><img className="images" src={ongoingActionCompleted ? add : add_disable} />
                        <div style={{ pointerEvents:(ongoingActionCompleted) ? "auto":"none" , color: ongoingActionCompleted ? "inherit" : "grey", display: "inline-block", marginLeft: "5px",cursor:"pointer",textDecoration:"underline" }} onClick={
                            ongoingActionCompleted ? addWorkScheduleGrouping : undefined
                        } > Add </div>
                    </div>
                    <div className={eventClasses.eventicon2} > <img className="images" src={ongoingActionCompleted ? deleteimg : delete_disable} />
                        <span style={{ pointerEvents:(ongoingActionCompleted) ? "auto":"none" , color: ongoingActionCompleted ? "inherit" : "grey", marginLeft: "5px",cursor:"pointer",textDecoration:"underline" }} onClick={
                            ongoingActionCompleted ? showDeleteDialog : undefined
                        }>Delete</span>
                    </div>
                </div>
            </div>
            <Box>
                <Dialog
                    open={dialog.open}
                    title={'Delete Work Schedule'}
                    onClose={dialog.hide}

                    actions={
                        <>
                            <>
                                <Button color="secondary" onClick={dialog.hide}>No</Button>
                                <Button onClick={deleteWorkSchedule}>Yes</Button>
                            </>
                        </>
                    }

                >
                    <Typography>Are you sure you want to delete this work schedule {workSchedule} across all divisions?</Typography>

                </Dialog>
            </Box>
            {readOnlyView &&
                <NotificationView
                    message={"'Read-only' view, click on 'Edit' to edit work schedule details."} severity="info" />
            }
            <div className={eventClasses.eventiconmargin}>


                <div className={classes.pagesubtitle}> </div>
                { /*  Event details code goes here */}

                <div>


                    <div className={eventClasses.eventpagemargin}>
                        <Grid container spacing={4} rowSpacing={6}>
                            <Grid key={0} item xs={6}>
                                <FormControl style={{ minWidth: '100%' }}>
                                    <TextField
                                        label="Work Schedule"
                                        onChange={(e) => setWorkSchedule(e.target.value)}
                                        value={workSchedule}
                                        required
                                        error={isDirty.work && workSchedule === "" ? true : false}
                                        onBlur={() => setTouched("work")}
                                        helperText={isDirty.work && workSchedule === "" ? `Work schedule required` : ""}
                                        readOnly={readOnlyView}
                                        inputProps={{ readOnly: readOnlyView }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid key={1} item xs={2}>
                                <FormControl style={{ minWidth: '100%' }}>
                                    <TextField
                                        label="Group ID"
                                        onChange={(e) => setGroupId(e.target.value)}
                                        value={groupId}
                                        required
                                        error={isDirty.group && groupId === "" ? true : false}
                                        onBlur={() => setTouched("group")}
                                        helperText={isDirty.group && groupId === "" ? "Group ID required" : ""}
                                        readOnly={readOnlyView}
                                        inputProps={{ readOnly: readOnlyView }}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid key={2} item xs={4}></Grid>
                            <Grid key={3} item xs={4}></Grid>
                            <Grid key={4} item xs={2}>
                            {!readOnlyView && <Button onClick={cancelEditing} color="secondary" size="large" style={{
                                    minWidth: '100%',
                                    minHeight: '120%',
                                }}>
                                    Cancel
                                </Button>
                            }
                            </Grid>
                            <Grid key={5} item xs={2}>
                            {readOnlyView &&
                                <Button sx={{ minWidth: "100%" }} color="primary" size="large" onClick={makeEditable} >Edit</Button>
                        
                            }    
                            {!readOnlyView &&
                                <Button color="primary" size="large" style={{
                                    minWidth: '100%',
                                    minHeight: '120%',
                                }} onClick={saveData}>
                                    Save
                                </Button>
                            }
                            </Grid>
                        </Grid>


                    </div>
                </div>

                <SnackBar
                    open={open}
                    message={message}
                    severity={severity}
                    onClose={handleAlertNotifClose}
                ></SnackBar>

            </div>
        </div>
    )

        ;
}
export default AddEditWorkScheduleGrouping;